import React from 'react';
import { PrivateLayout, PV_THEME } from '../PrivateLayout';

const T = PV_THEME;

const CV = {
  Education: [
    'BA (Hons) Painting, Camberwell College of Arts, University of the Arts London — 2007-2010',
    'Foundation, Fine Art (Painting), Chelsea College of Arts, London — 2006-2007',
  ],
  'Solo Exhibitions': [
    'Time Honoured · Kasmin · New York · 2025',
    'In Voluntary Absence · 1st Floor · Green Park · Bath · 2024-2025',
    'To See Beyond Seeing · Simon Lee Gallery · London · 2023',
    'In One Breath · French Riviera · London · 2022',
    'Things of The World · online · 2021',
    'Flesh & Spirit · Bow Arts · Thamesmead · London · 2020',
    'Achịcha · Studio 1.1 · Shoreditch · London · 2019',
    'Money, Love, Jealousy · OM\'s · Victoria Island · Lagos · 2019',
    'Space In Between · Seesaw Studio · Dalston · London · 2018',
  ],
  'Group Exhibitions': [
    'Repose · William Hine · London · 2025-2026',
    'Codex · Centre For Recent Drawing · London · 2025',
    'Wings Of A Butterfly · Ingleby · Edinburgh · 2025',
    'of intimacy and quietude · Sid Motion Gallery · London · 2024',
    'Image Impressions · FF Projects · Lagos · 2023',
    'Time · Pablo\'s Birthday · New York · 2023',
    'Cosmic Coincidences · French Riviera · London · 2022',
    'Manifold · FF Projects · London · 2022',
    'Gertrude Presents · London · 2022',
    'Leo Asemota & Helena Foster: Materials For A Performance Of Unknown Reasons · London · 2022',
    'Elbow Room · The Sunday Painter · London · 2022',
    'EQX 22. 20:20. 21 · French Riviera · London · 2021',
    'Art X Lagos · Septieme Gallery · 2021',
    'Entre Amis Trois · French Riviera · London · 2020',
    'Viva la Fiesta · French Riviera · Bethnal Green · London · 2020',
    'Entre Amis Deux · French Riviera · Bethnal Green · London · 2019',
    'Black · The Crypt Gallery · St Pancras · London · 2018',
    '50 / 50 · The Crows Nest Gallery · London · 2018',
    'Encounter · Jewel Piccadilly · London · 2018',
    'Art Hub Gallery · Deptford · London · 2017',
    'Storytelling · Remp Art Gallery · Marrakech · 2010',
    'Degree show · Camberwell College of Arts · 2010',
    'Youth Art Interchange II: A sense of perspective · Tate Britain · 2009',
  ],
  'Curatorial & Collaborative Projects': [
    'Lagos Biennial: How to Build A Lagoon with Just A Bottle of Wine · Guest Projects · Shonibare Studios · London · 2019',
    'Foundations in Curating · Sotheby\'s Institute of Art · London · 2018',
    'Tate Collective Talk · Tate Britain · London · 2017',
    'Modern & Contemporary African Art · Sotheby\'s Institute of Art · London · 2016',
    'Adidas Collaboration: "When I see you, I See Me" · Late at Tate · 2015',
    'Power Myth & Technology — a one-day symposium · Tate Modern · 2013',
    'Hyperlink – Circuit · Tate Modern · London · 2013',
    'Benjamin, Benin and Britain: A Diamond Jubilee · The British Museum · London · 2012',
    'The Ens Project: "Count Off for Eo Ipso" Leo Asemota · Tate Tanks · Tate Modern · 2012',
    'Controversy in Art · Art Session · Centre Pompidou · Paris · 2011',
    'Louis Vuitton Young Arts Project Summer Academy · 2010',
    'Britishistory Series · Make it up, Mix it up & Talk it up · Tate Britain · 2010',
    'Fearless · Kultu · Kiasma Museum of Contemporary Art · 2010',
    'UK-China 400: Creativity and Cultural Innovation · British Council · Shanghai · 2009',
  ],
  'Residency': [
    'Thamesmead Texas · Thamesmead · London · 2020',
    'Terre Sans Frontiere | And\'Art · Marrakech · Morocco · 2010',
  ],
  Features: [
    'Plus Magazine · Helena Foster: Between the Seen and the Felt · 2025',
    'Manifold Archives · FF Projects · 2024',
    'Konfekt Kompakt — Issue 62 · Home Truths / Helena Foster: Refined Palette · 2023',
    'MoMus · Preoccupied with Things Left Behind: On Three Nigerian Artists · 2022',
    'England: Talking of Art — Contemporary Artists from England · Imago Mundi · 2020',
    'Good Trouble Magazine · Issue 22 · August 2018: UNMANIFESTO',
    'Under The Influence Magazine · The Africa issue · 2012',
    'Issues of Identity, Purpose and Direction — Conversation between Jelili Atiku and Helena Foster',
  ],
};

export default function ArtistCVSection() {
  return (
    <PrivateLayout eyebrowLabel="Artist CV · Helena Foster" testid="pv-artist-cv">
      <section className="relative z-10 max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-12">
        <p className="font-mono uppercase mb-3" style={{ fontSize: 10, letterSpacing: '0.4em', color: '#6B4226' }}>
          [ .VIII. .CASE.STUDY. ]
        </p>
        <h1 className="font-machina font-bold uppercase mb-4" style={{ fontSize: 'clamp(32px,6vw,56px)', lineHeight: 0.95, color: T.text }}>
          Helena Foster.<br />Reference CV.
        </h1>
        <p className="font-mono leading-[1.8] max-w-2xl" style={{ fontSize: 13, color: T.textMuted }}>
          Helena Foster is the case-study artist threaded through the TrustFrame Settlement Calculator. Camberwell BA. Tate Collective alumna. Solo exhibitions Kasmin (NY), Simon Lee, French Riviera. Below: full reference CV used to demonstrate tier mapping, markup multipliers, and 50/50 escrow splits inside the platform.
        </p>
        <div className="font-mono mt-6 inline-flex items-center gap-3 px-3 py-2" style={{ fontSize: 10, letterSpacing: '0.25em', color: '#a0907a', border: `1px solid ${T.border}`, textTransform: 'uppercase' }}>
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: '#A0522D' }} />
          Tier: Mid-Career · ×1.8 multiplier
        </div>
      </section>

      <section className="relative z-10 max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="space-y-12">
          {Object.entries(CV).map(([title, entries], idx) => (
            <div key={title}>
              <div className="flex items-center gap-4 mb-4">
                <span className="font-mono" style={{ fontSize: 10, color: T.textFaint }}>
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <h2 className="font-machina font-bold uppercase" style={{ fontSize: 15, letterSpacing: '0.18em', color: T.accent }}>{title}</h2>
                <div className="h-px flex-1" style={{ background: T.border }} />
              </div>
              <ul className="space-y-2">
                {entries.map((e) => (
                  <li
                    key={e}
                    className="font-sans leading-[1.7] pl-5 relative"
                    style={{ fontSize: 12, color: T.textMuted }}
                  >
                    <span className="absolute left-0" style={{ color: T.textFaint }}>›</span>
                    {e}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </PrivateLayout>
  );
}
